import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import RenderSteps from "../AddCourse/RenderSteps";
import { getFullDetailsOfCourse } from "../../../../services/operations/courseDetailsAPI";
import { setCourse, setEditCourse } from "../../../../slices/courseSlice";

function EditCourse(props) {
  const dispatch = useDispatch();
  const { courseId } = useParams();
  const { course } = useSelector((state) => state.course);
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  
  useEffect(() => {
      const populateCourseDetails = async () => {
          setLoading(true);
          const result = await getFullDetailsOfCourse(courseId, token);
          if (result?.courseDetails) {
              dispatch(setEditCourse(true));
              // to edit course
              // set course
              dispatch(setCourse(result?.courseDetails));
            }
            
            setLoading(false);
        };
        populateCourseDetails()
    }, []);
    
    // is loading is above use effect there is an error
    if (loading) {
      return <div className='flex w-full h-screen justify-center items-center'>
              <div className='spinner'></div>
             </div> 
      // <div className="spinner flex justify-center items-center"></div>;
    }

  return (
    <div>
      <p>Edit Course</p>
      <div>{course ? <RenderSteps /> : <p>Course Not Found</p>}</div>
    </div>
  );
}

export default EditCourse;
